import { LoginVerifyPage } from "@/features/auth/pages/LoginVerify";

const LoginVerify = () => {
  return <LoginVerifyPage />;
};

export default LoginVerify;
